import type { SiteAppearance } from './site-appearance';
export function siteViewerUrl(
  locationId: string,
  versionId: string,
  appearance: SiteAppearance | null
) {
  const search = new URLSearchParams({ locationId, versionId });
  if (appearance?.style) search.set('style', appearance.style);
  if (appearance?.style === 'signature' && appearance.palette)
    for (const [key, value] of Object.entries(appearance.palette))
      search.set(key, value);
  if (appearance?.spacing) search.set('spacing', appearance.spacing);
  return `/website-preview?${search}`;
}
